import axios from 'axios'

const axiosVestaApi = axios.create({
  baseURL: `${process.env.REACT_APP_VESTA_BACKEND_URL}/v1`,
})

export const getProvinces = async () => {
  const response = await axiosVestaApi.get('/locations/province')
  return response.data?.data
}

export const getCities = async ({ province_id }) => {
  const response = await axiosVestaApi.get('/locations/city', {
    params: {
      province_code: province_id,
    },
  })

  return response.data?.data
}

export const getDistricts = async ({ city_id }) => {
  const response = await axiosVestaApi.get('/locations/district', {
    params: {
      city_code: city_id,
    },
  })
  return response.data?.data
}

export const getSubdistricts = async ({ district_id }) => {
  const response = await axiosVestaApi.get('/locations/subdistrict', {
    params: {
      district_code: district_id,
    },
  })
  return response.data?.data
}
